import cookie from 'cookie'

import { isBrowser } from './env'

export function getCookies() {
  return cookie.parse(isBrowser() ? document.cookie : '')
}

export function getCookie(name: string) {
  const cookies = getCookies()
  return cookies[name] || ''
}

export function setCookie(
  name: string,
  value: string,
  options: cookie.CookieSerializeOptions = {},
) {
  if (options && options.httpOnly) {
    throw new Error('Can not set a httpOnly cookie in the browser.')
  }

  document.cookie = cookie.serialize(name, value, options)
}

export function removeCookie(
  name: string,
  options: cookie.CookieSerializeOptions = {},
) {
  if (options && options.httpOnly) {
    throw new Error('Can not set a httpOnly cookie in the browser.')
  }

  setCookie(name, '', { ...(options || {}), maxAge: -1 })
}
